import type { FaireProductEntity } from "../../entity_types/product";

export const p_ryqnqp9p6w: FaireProductEntity = {
  token: "p_ryqnqp9p6w",
  type: "product",
  name: "LM-BG-1003 TOTE BAG RED/WHT STRIPE",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/cd525a04cf24062b0ee66b6419abff25c09deef4f61df8ccbb2063fbd30307df.png",
  galleryImageUrls: [],
  priceDollars: 15,
  description: "This tote from Girlie Girl Originals delivers casual charm and functional design for use. Thoughtfully constructed to carry essentials with ease, its striped red and white look brings a touch of lively flair to outings, errands, or weekend plans while complementing a variety of wardrobe choices.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:11.625Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
